var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSimplified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A2937",
    d: "M0 0h18v21H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.415 2.06C10.35-.687 5.653-.687 2.586 2.06-.8 5.098-.856 10.321 2.39 13.503L7.995 19h.01l5.605-5.497c3.246-3.182 3.19-8.405-.195-11.443z",
    stroke: "#A0A5AC",
    strokeWidth: 0.25,
    fill: "#243942",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#999",
    cx: 8,
    cy: 8,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D1D2D3",
    strokeWidth: 0.75,
    fill: "#DDB436",
    cx: 8,
    cy: 8,
    r: 3.625
  })))));
}
export default __webpack_public_path__ + "static/media/30a0402da117e629cc298891c8725213-logo-simplified.svg";
export { SvgLogoSimplified as ReactComponent };